import { FC, useEffect } from 'react';
import { changePlaywireForcePathBySitePath, playwireDoChangePath } from '../../services/advertisingService';

type TPlaywireForcePathProps = {
  forcePath?: string;
  useDefault?: boolean;
};

export const PlaywireForcePath: FC<TPlaywireForcePathProps> = (props) => {
  useEffect(() => {
    if (props.useDefault) {
      changePlaywireForcePathBySitePath(window.location.pathname);
    } else {
      playwireDoChangePath(props.forcePath || '');
    }
  }, [props.forcePath, props.useDefault || false]);

  return null;
};
